import { createAsyncThunk } from "@reduxjs/toolkit";
import { organizationListShortService } from "services";

export const fetchingListShortOrganization = createAsyncThunk(
  "system/fetchingListShortOrganization",
  async () => {
    const listShort = await organizationListShortService();
    return listShort?.data;
  }
);
